<!-- 
Layout for "anonymous" pages. This layout is used for pages such as the sign-in page,
where we don't yet know who the user is.
-->
<template>
  <div>
    <v-content>
      <div class="scroll-container">
        <slot/>
      </div>
    </v-content>
    <notification-snackbar />
  </div>
</template>

<script>
import NotificationSnackbar from "@/components/system/NotificationSnackbar.vue";

export default {
  components: { NotificationSnackbar },
  computed: {
    isSignedIn() {
      return this.$store.getters.isSignedIn;
    },
    onHomePage() {
      return this.$route.path == "/";
    },
    onChangePasswordPage() {
      return this.$route.path == "/change-password";
    },
    environment() {
      return this.$store.getters.environmentForToolbar;
    }
  }
};
</script>
